import { PathsOf } from '@/types/subform';

export interface AssetIntegrationFormShape {
  integrationEntityIds: string[];
  /** linkToAllAddeparEntities allows the user to link to any Addepar entity that the system is aware of,
     such as an entity owned by a client that's not one of the clients in the household. This is useful for
     situations when the client is a beneficiary of a trust that's modeled as being owned by their parents
     or grandparents in Addepar */
  linkToAllAddeparEntities: boolean;
  /** allowAdditionalManualAssets allows the user to add additional manual assets to the entity even if it's linked
     to an integration. This is useful for situations when the entity in the external system is missing important
     assets (typically real estate or similar) that are important to the valuation. It's common for customers to not
     put those assets on the entity in Addepar to avoid paying AUM fees on them. */
  allowAdditionalManualAssets: boolean;
  /** showAllIntegratedHoldings controls whether we create an Luminary asset for each integrated holding. If not enabled (the default), we group integrated
   * holdings like so: group by account name, then group by asset class.
   * This is stored as the inverse of groupIntegrationAssetValues because the default is to group holdings, but want the UI to default
   * to false.
   */
  showAllIntegratedHoldings: boolean;
}

export const defaultValues: AssetIntegrationFormShape = {
  integrationEntityIds: [],
  linkToAllAddeparEntities: false,
  allowAdditionalManualAssets: false,
  showAllIntegratedHoldings: false,
};

export type PathsOfAssetIntegrationFormShape =
  PathsOf<AssetIntegrationFormShape>;
